import React from 'react'
import LinkMenuPrimary from './LinkMenuPrimary'

function MenuPrimary() {
  return (
    <nav id='nav-primary'>
        <LinkMenuPrimary idSection='home-section' name='Inicio'/>
        <LinkMenuPrimary idSection='insta-section' name='Instagram'/>
        <LinkMenuPrimary idSection='tiktok-section' name='Tiktok'/>
        <LinkMenuPrimary idSection='awards-section' name='Premiações'/>
        <LinkMenuPrimary idSection='spotify-section' name='Spotify'/>
        <LinkMenuPrimary idSection='product-section' name='Loja'/>
    </nav>
  )
}

export default MenuPrimary
